import { LitElement, html, css } from '@hh/global.js'

class HHRadioWrapper extends LitElement {
  static properties = {
    disabled: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  firstUpdated() {
    this.disabled = this.input.disabled
    this.checked = this.input.checked
  }

  get input() {
    const slot = this.shadowRoot?.querySelector(`slot[name='input']`)
    return slot?.assignedNodes()[0] ?? null
  }

  render() {
    return html`
      <slot name="input" part="input"></slot>
      <slot name="label" part="label"></slot>
    `
  }

  static styles = css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    :host {
      display: inline-flex;
      align-items: center;
    }

    ::slotted(input) {
      appearance: none;
      touch-action: none;
      margin: 0;
      width: var(--hh-width, 1.6rem);
      height: var(--hh-height, 1.6rem);
      border: 1px solid var(--hh-color-input-border, var(--hh-color-subdued));
      border-radius: var(--hh-border-radius, 50%);
      position: relative;
      cursor: pointer;
    }

    ::slotted(input:checked) {
      border-color: 1px solid var(--hh-color, var(--hh-color-ink));
    }

    ::slotted(input)::before {
      content: '';
      pointer-events: none;
      width: calc(var(--hh-width, 1.6rem) / var(--hh-dot-to-border-ratio, 2));
      height: calc(var(--hh-height, 1.6rem) / var(--hh-dot-to-border-ratio, 2));
      border-radius: var(--hh-border-radius, 50%);
      background-color: var(--hh-color, #000);
      scale: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    ::slotted(input:checked)::before {
      scale: 1;
    }

    ::slotted(input:focus) {
      border: 1px solid var(--hh-color, #646464) !important;
    }

    ::slotted(input:disabled) {
      border-color: var(--hh-color-input-border-disabled);
      cursor: not-allowed;
    }

    ::slotted(label) {
      cursor: pointer;
      padding-left: var(--hh-column-gap, var(--hh-space-xs));
    }

    :host([disabled]) ::slotted(label) {
      cursor: not-allwoed;
    }
  `
}

customElements.define('hh-radio-wrapper', HHRadioWrapper)
